import React from "react";
import "./App.css";
import Result from "antd/es/result";

import Button from "antd/es/button";
import notification from "antd/es/notification";
import Spin from "antd/es/spin";
import Video from "twilio-video";
import ClearCache from "react-clear-cache";
import Room from "./Room";
import BlankCache from "./BlankCache";
import helper from "./utils/helper";
import Queue from "./components/Queue";
import Emitter from "./utils/emitter";
import http from "./utils/http";

function VideoCall(props) {
  const [room, setRoom] = React.useState(null);
  const [retrieve, setRetrieve] = React.useState(null);
  const [queue, setQueue] = React.useState({ inQueue: 0, queuePosition: 0 });
  const [error, setError] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [waiting, setWaiting] = React.useState(false);
  const [audioStatus, setAudioStatus] = React.useState(true);
  const [videoStatus, setVideoStatus] = React.useState(true);
  const [response, setResponse] = React.useState(null);
  const sid = decodeURIComponent(window.location.search?.replace("?data=", ""));

  React.useEffect(() => {
    setLoading(true);
    const sidParams = new URLSearchParams(window.location.search).get("sid");
    const type = new URLSearchParams(window.location.search).get("type");

    if (type === "sharing") {
      if (sidParams) {
        setLoading(true);
        http
          .get(
            `${process.env.REACT_APP_API_URL}/${
              process.env.REACT_APP_TENANT
            }/sharing/${sidParams}?timestamp=${new Date().getMilliseconds()}`
          )
          .then((res) => {
            setLoading(false);
            onConnectSharing(sidParams, res.data.token);
          })
          .catch(() => {
            setLoading(false);
            let qp = new URLSearchParams();
            qp.set("sid", "");
            qp.set("type", "");
            window.history.replaceState(null, null, "?" + qp.toString());
          });
      }
    } else {
      if (localStorage.getItem("sid") || sidParams) {
        if (parseInt(process.env.REACT_APP_USE_LOCATION) === 1) {
          http.post(
            `${process.env.REACT_APP_API_URL}/${
              process.env.REACT_APP_TENANT
            }/updateLocation?timestamp=${new Date().getMilliseconds()}`,
            {
              sid: sidParams ? sidParams : localStorage.getItem("sid"),
              location: {
                latitude: props.lat,
                longitude: props.long,
              },
            }
          );
        }

        http
          .get(
            `${process.env.REACT_APP_API_URL}/${
              process.env.REACT_APP_TENANT
            }/sessionStatus/${
              sidParams ? sidParams : localStorage.getItem("sid")
            }?timestamp=${new Date().getMilliseconds()}`
          )
          .then((res) => {
            http
              .get(
                `${process.env.REACT_APP_API_URL}/${
                  process.env.REACT_APP_TENANT
                }/session/${
                  sidParams ? sidParams : localStorage.getItem("sid")
                }?timestamp=${new Date().getMilliseconds()}`
              )
              .then((resp) => {
                setLoading(false);
                resp.data.status = res.data;
                setResponse(resp.data);
                if (res.data === "waiting" || res.data === "initiated") {
                  onWait(
                    resp.data.token,
                    resp.data.room.uniqueName,
                    resp.data.body.email
                  );
                } else {
                  onConnect(
                    resp.data.token,
                    resp.data.room.uniqueName,
                    resp.data.body.email
                  );
                }
              })
              .catch(() => {
                setLoading(false);
                let qp = new URLSearchParams();
                qp.set("sid", "");
                window.history.replaceState(null, null, "?" + qp.toString());
                localStorage.removeItem("sid");
              });
          })
          .catch(() => {
            setLoading(false);
            let qp = new URLSearchParams();
            qp.set("sid", "");
            window.history.replaceState(null, null, "?" + qp.toString());
            localStorage.removeItem("sid");
          });
      } else {
        if (helper.isJsonString(helper.decryptClient(sid))) {
          const decryptData = JSON.parse(helper.decryptClient(sid));
          http
            .post(
              `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_TENANT}/requestQueue`,
              { ...decryptData, platform: "vonage" }
            )
            .then((res) => {
              if (res) {
                setResponse(res.data);
                setLoading(false);
                setRetrieve(res.data.room);
                if (res.data.body?.email) {
                  onWait(
                    res.data.token,
                    res.data.room.uniqueName,
                    res.data.body?.email,
                    res.data.room
                  );
                } else {
                  onWait(
                    res.data.token,
                    res.data.room.uniqueName,
                    res.data.body?.phone,
                    res.data.room
                  );
                }
              }
            })
            .catch((err) => {
              console.log(err);
              setLoading(false);
              setError(true);
            });
        } else {
          setLoading(false);
          setError(true);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (response) {
      const parameterVidcall = JSON.stringify({
        tenant_id: process.env.REACT_APP_TENANT,
        userid: response?.body?.email,
        type: "customer",
        room: response?.room?.uniqueName,
      });

      const paramsVidcall = helper.encrypt(parameterVidcall);

      let socketVidcall = window.io(process.env.REACT_APP_API_URL, {
        path: `/${process.env.REACT_APP_TENANT}/socket.io`,
        query: { data: paramsVidcall },
        transports: ["websocket"],
      });

      if (response?.status !== "handling") {
        checkQueue(response?.room?.uniqueName);
      }

      const intervalQueue = setInterval(() => {
        if (response?.status !== "handling") {
          checkQueue(response?.room?.uniqueName);
        } else {
          clearInterval(intervalQueue);
        }
      }, 30000);

      socketVidcall.on("accept_video_call", (data) => {
        setLoading(false);
        clearInterval(intervalQueue);
        onConnect(
          response?.token,
          response?.room?.uniqueName,
          response?.body?.email
        );
      });

      socketVidcall.on("end_video_call", (data) => {
        localStorage.removeItem("sid");
        handleLogout();
      });

      socketVidcall.on("newChatVideoCall", (data) => {
        Emitter.emit("MESSAGE_SET", JSON.parse(helper.decrypt(data)));
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response]);

  const onConnect = async (token, name, email) => {
    const videoTrack = await Video.createLocalVideoTrack();
    const audioTrack = await Video.createLocalAudioTrack();
    setLoading(true);
    Video.connect(token, {
      name: name,
      tracks: [videoTrack, audioTrack],
      insights: false,
      video: { frameRate: 24, facingMode: { exact: "environment" } },
      maxAudioBitrate: 16000,
      networkQuality: { local: 1, remote: 1 },
    })
      .then((room) => {
        setRoom(room);
        setWaiting(false);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        let qp = new URLSearchParams();
        qp.set("sid", "");
        window.history.replaceState(null, null, "?" + qp.toString());
        localStorage.removeItem("sid");
        notification.error({
          message: "Video call tidak dapat tersambung, coba lagi nanti.",
          placement: "bottomRight",
          duration: 5,
        });
      });
  };

  const onConnectSharing = (sid, token) => {
    const name = localStorage.getItem("name")
      ? localStorage.getItem("name")
      : helper.makeid(6);
    const email = name + "@gmail.com";
    localStorage.setItem("name", name);
    const parameterVidcall = JSON.stringify({
      tenant_id: process.env.REACT_APP_TENANT,
      userid: email,
      type: "customer",
      room: sid,
    });

    const paramsVidcall = helper.encrypt(parameterVidcall);

    let socketVidcall = window.io(process.env.REACT_APP_API_URL, {
      path: `/${process.env.REACT_APP_TENANT}/socket.io`,
      query: { data: paramsVidcall },
      transports: ["websocket"],
    });

    socketVidcall.on("accept_video_call", (data) => {
      setLoading(false);
      onConnect(token, sid, email);
    });

    socketVidcall.on("end_video_call", (data) => {
      localStorage.removeItem("sid");
      handleLogout();
    });

    socketVidcall.on("newChatVideoCall", (data) => {
      Emitter.emit("MESSAGE_SET", JSON.parse(helper.decrypt(data)));
    });
    onConnect(token, sid, "");
  };

  const onWait = async (token, name, email, roomData) => {
    setWaiting(true);
  };

  const checkQueue = (roomData) => {
    http
      .get(
        `${process.env.REACT_APP_API_URL}/${
          process.env.REACT_APP_TENANT
        }/queuePosition/${
          roomData?.sid
        }?timestamp=${new Date().getMilliseconds()}`
      )
      .then((res) => {
        setQueue(res.data);
      });
  };

  const handleLogout = React.useCallback(() => {
    setRoom((prevRoom) => {
      if (prevRoom) {
        prevRoom.localParticipant.tracks.forEach((trackPub) => {
          trackPub.track.stop();
        });
        prevRoom.disconnect();
      }
      localStorage.removeItem("sid");
      if (window.NativeJavascriptInterface) {
        // Call Android interface
        window.NativeJavascriptInterface.postMessage("rating");
        window.open("sapaPegadaian://rating?type=VideoCall", "_self");
      } else if (window.webkit && window.webkit.messageHandlers) {
        // Call iOS interface
        window.webkit.messageHandlers.callbackHandler.postMessage("rating");
      } else {
        window.open("sapaPegadaian://rating?type=VideoCall", "_self");
      }
      //window.location.href = process.env.REACT_APP_REDIRECT_URL;
      return null;
    });
  }, []);

  React.useEffect(() => {
    if (room) {
      const tidyUp = (event) => {
        if (event.persisted) {
          return;
        }
        if (room) {
          handleLogout();
        }
      };
      window.addEventListener("pagehide", tidyUp);
      window.addEventListener("beforeunload", tidyUp);
      return () => {
        window.removeEventListener("pagehide", tidyUp);
        window.removeEventListener("beforeunload", tidyUp);
      };
    }
  }, [room, handleLogout]);

  const handleAudio = () => {
    room.localParticipant.audioTracks.forEach((publication) => {
      if (audioStatus) {
        publication.track.disable();
      } else {
        publication.track.enable();
      }
    });
    setAudioStatus(!audioStatus);
  };

  const handleVideo = (status) => {
    setVideoStatus(status);
    room.localParticipant.videoTracks.forEach((publication) => {
      if (!status) {
        publication.track.enable(false);
      } else {
        publication.track.enable(true);
      }
    });
  };

  return (
    <Spin spinning={loading} tip="Sedang memproses..." className="h-full">
      {!error ? (
        <>
          {room && !waiting ? (
            <Room
              response={response}
              room={room}
              handleLogout={handleLogout}
              audioStatus={audioStatus}
              handleAudio={handleAudio}
              videoStatus={videoStatus}
              handleVideo={handleVideo}
            />
          ) : null}
          {waiting && (
            <Queue
              setWaiting={setWaiting}
              queue={queue}
              handleLogout={handleLogout}
              response={{
                room: {
                  uniqueName: retrieve?.uniqueName,
                },
              }}
            />
          )}
        </>
      ) : (
        <Result
          title="SapaPegadaian"
          subTitle="Tidak ada sesi video call berlangsung."
          extra={[
            <Button
              key="buy"
              onClick={() => {
                if (window.NativeJavascriptInterface) {
                  // Call Android interface
                  window.NativeJavascriptInterface.postMessage("rating");
                  window.open("sapaPegadaian://rating?type=VideoCall", "_self");
                } else if (window.webkit && window.webkit.messageHandlers) {
                  // Call iOS interface
                  window.webkit.messageHandlers.callbackHandler.postMessage(
                    "rating"
                  );
                } else {
                  window.open("sapaPegadaian://rating?type=VideoCall", "_self");
                }
              }}
            >
              Tutup
            </Button>,
          ]}
        />
      )}
    </Spin>
  );
}

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error_name: "",
      error_description: "",
      error_line: "",
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error_name: error.message,
      error_description: errorInfo.componentStack,
      error_line: errorInfo.componentStack.split(":")[0],
    });
  }

  render() {
    return (
      <ClearCache>
        {({ isLatestVersion, emptyCacheStorage }) =>
          !isLatestVersion ? (
            <BlankCache emptyCacheStorage={emptyCacheStorage} />
          ) : (
            <VideoCall {...this.props} />
          )
        }
      </ClearCache>
    );
  }
}

export default App;
